/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Item1
 */
export interface Item1 {
    /**
     * 
     * @type {number}
     * @memberof Item1
     */
    sourceOrderId?: number;
    /**
     * 
     * @type {number}
     * @memberof Item1
     */
    goodsId?: number;
    /**
     * 查询时的历史商品结构签名，用于提交时复核
     * @type {string}
     * @memberof Item1
     */
    structureSignature?: string;
    /**
     * 
     * @type {string}
     * @memberof Item1
     */
    marketBarcode?: string;
    /**
     * 合并后的全部来源商品ID，仅用于核对同会员/仓库/构成及来源追溯。
     * @type {Array<number>}
     * @memberof Item1
     */
    sourceGoodsIds?: Array<number>;
    /**
     * 返送数量，正整数；合包按套数，不限制历史出库数量
     * @type {number}
     * @memberof Item1
     */
    quantity?: number;
}

/**
 * Check if a given object implements the Item1 interface.
 */
export function instanceOfItem1(value: object): value is Item1 {
    return true;
}

export function Item1FromJSON(json: any): Item1 {
    return Item1FromJSONTyped(json, false);
}

export function Item1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Item1 {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceOrderId': json['sourceOrderId'] == null ? undefined : json['sourceOrderId'],
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'structureSignature': json['structureSignature'] == null ? undefined : json['structureSignature'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'sourceGoodsIds': json['sourceGoodsIds'] == null ? undefined : json['sourceGoodsIds'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function Item1ToJSON(json: any): Item1 {
    return Item1ToJSONTyped(json, false);
}

export function Item1ToJSONTyped(value?: Item1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceOrderId': value['sourceOrderId'],
        'goodsId': value['goodsId'],
        'structureSignature': value['structureSignature'],
        'marketBarcode': value['marketBarcode'],
        'sourceGoodsIds': value['sourceGoodsIds'],
        'quantity': value['quantity'],
    };
}

